module.exports = __webpack_public_path__ + "empty_user.png?a31fde987eb8e5149d36d33831c96004";